// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"315":"plugin.echarts","371":"plugin.networkgraph","395":"plugin.datepicker-single","725":"module.admin"}[chunkId] || chunkId) + ".js?v=" + {"6":"97338d00ae44b4485e93","315":"5b2cc3f625a223552e0e","371":"8d73b3d54b68ef54152c","395":"2e3916888a6e686add93","725":"434a1d12c45694ba169d"}[chunkId] + "";
};